import { Link } from "react-router-dom";

const serviceAreaGroups = [
  {
    header: "Metro Detroit (Primary)",
    cities: [
      { name: "Northville", href: "/hardwood-flooring/northville-mi" },
      { name: "Livonia", href: "/hardwood-flooring/livonia-mi" },
      { name: "Plymouth", href: "/hardwood-flooring/plymouth-mi" },
      { name: "Birmingham", href: "/hardwood-flooring/birmingham-mi" },
    ],
  },
  {
    header: "Metro Detroit (Extended)",
    cities: [
      { name: "Bloomfield Hills", href: "/hardwood-flooring/bloomfield-hills-mi" },
      { name: "Troy", href: "/hardwood-flooring/troy-mi" },
      { name: "West Bloomfield", href: "/hardwood-flooring/west-bloomfield-mi" },
      { name: "Farmington Hills", href: "/hardwood-flooring/farmington-hills-mi" },
      { name: "Novi", href: "/hardwood-flooring/novi-mi" },
      { name: "Canton", href: "/hardwood-flooring/canton-mi" },
      { name: "Rochester Hills", href: "/hardwood-flooring/rochester-hills-mi" },
      { name: "Dearborn", href: "/hardwood-flooring/dearborn-mi" },
      { name: "Grosse Pointe", href: "/hardwood-flooring/grosse-pointe-mi" },
      { name: "Orchard Lake", href: "/hardwood-flooring/orchard-lake-mi" },
      { name: "Wixom", href: "/hardwood-flooring/wixom-mi" },
    ],
  },
  {
    header: "Ann Arbor Corridor",
    cities: [
      { name: "Ann Arbor", href: "/hardwood-flooring/ann-arbor-mi" },
      { name: "Brighton", href: "/hardwood-flooring/brighton-mi" },
      { name: "Dexter", href: "/hardwood-flooring/dexter-mi" },
      { name: "Saline", href: "/hardwood-flooring/saline-mi" },
      { name: "Ypsilanti", href: "/hardwood-flooring/ypsilanti-mi" },
      { name: "Chelsea", href: "/hardwood-flooring/chelsea-mi" },
      { name: "South Lyon", href: "/hardwood-flooring/south-lyon-mi" },
      { name: "Pinckney", href: "/hardwood-flooring/pinckney-mi" },
    ],
  },
  {
    header: "Northern Michigan",
    cities: [
      { name: "Harbor Springs", href: "/hardwood-flooring/harbor-springs-mi" },
      { name: "Petoskey", href: "/hardwood-flooring/petoskey-mi" },
      { name: "Traverse City", href: "/hardwood-flooring/traverse-city-mi" },
      { name: "Charlevoix", href: "/hardwood-flooring/charlevoix-mi" },
      { name: "Bay Harbor", href: "/hardwood-flooring/bay-harbor-mi" },
      { name: "Bellaire", href: "/hardwood-flooring/bellaire-mi" },
      { name: "Leelanau", href: "/hardwood-flooring/leelanau-mi" },
    ],
  },
];

const PinIcon = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0" style={{ color: "var(--footer-gold)" }}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const FooterServiceAreas = () => (
  <div>
    <span
      className="text-[11px] font-semibold tracking-[0.08em] uppercase block mb-4"
      style={{ color: "var(--footer-text-tertiary)" }}
    >
      Service Areas
    </span>
    <div className="grid grid-cols-2 gap-x-6 gap-y-5">
      {serviceAreaGroups.map((group) => (
        <div key={group.header}>
          <span
            className="text-[13px] font-semibold flex items-center gap-1.5"
            style={{ color: "var(--footer-text-primary)" }}
          >
            <PinIcon />
            {group.header}
          </span>
          <div className="mt-1.5 ml-4 flex flex-col gap-0.5">
            {group.cities.map((city) => (
              <Link
                key={city.name}
                to={city.href}
                className="text-[12px] leading-[1.7] transition-colors duration-150 block"
                style={{ color: "var(--footer-text-secondary)" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-secondary)")}
              >
                {city.name}
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default FooterServiceAreas;